// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mZvK","index":"styles_index__2ZfZ3"};